import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import TableLoadingWrapper from "components/templates/TableLoadingWrapper";
import { StyledTableCell, StyledTableRow } from "components/templates/Tables";
import {
  Table,
  TableRow,
  TableBody,
  TableHead,
  TableContainer,
  Tooltip,
} from "@mui/material";
import { MODAL, modalActions } from "redux/slices/modal";
import DynamicService from "services/dynamics.service";
import Button from "components/atoms/Button";
import BlockComponent from "components/organisms/BlockComponent/BlockComponent";
import SubscriptionService from "services/subscription.service";
import DateService from "utils/date.util";

export default function ContentfulCache() {
  const dispatch = useAppDispatch();
  const contentfulCache = useAppSelector((state) => state.dynamics.contentfulCache || []);
  const loading = useAppSelector((state) => state.dynamics.loading);

  useEffect(() => {
    DynamicService.getContentfulCache();
  }, []);

  const handleDelete = (cacheId: string, key: string) => {
    SubscriptionService.subscribe(() => {
      DynamicService.deleteContentfulCache(cacheId);
    });
    dispatch(
      modalActions.openModal({
        width: "500px",
        type: MODAL.CONFIRMATION_FORM,
        data: {
          heading: "Delete Contentful Cache",
          message: `Are you sure you want to delete cache entry "${key}"?`,
        },
      })
    );
  };

  const truncateData = (data: any, maxLength: number = 100) => {
    if (!data) return "-";
    const str = typeof data === "string" ? data : JSON.stringify(data);
    return str.length > maxLength ? `${str.substring(0, maxLength)}...` : str;
  };

  return (
    <TableContainer>
      <Table
        aria-label="contentful cache table"
        sx={{
          minWidth: "100%",
          borderSpacing: "0 10px",
          borderBottomWidth: "0px",
          borderCollapse: "separate",
        }}
      >
        <TableLoadingWrapper
          coloumns={5}
          loading={loading}
          length={contentfulCache.length}
          message="No contentful cache entries found"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Key</StyledTableCell>
              <StyledTableCell>Locale</StyledTableCell>
              <StyledTableCell>Data</StyledTableCell>
              <BlockComponent permission={"dynamics:edit"}>
                <StyledTableCell align="right">Action</StyledTableCell>
              </BlockComponent>
            </TableRow>
          </TableHead>
          <TableBody>
            {contentfulCache.map((cache: any, i: number) => (
              <StyledTableRow key={cache._id || i}>
                <StyledTableCell>{cache.key || "-"}</StyledTableCell>
                <StyledTableCell>{cache.locale || "-"}</StyledTableCell>
                <StyledTableCell>
                  <Tooltip arrow title={truncateData(cache.data, 1000)}>
                    <span style={{ cursor: "help" }}>
                      {truncateData(cache.data, 100)}
                    </span>
                  </Tooltip>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <BlockComponent permission={"dynamics:delete"}>
                    <Button
                      size="small"
                      variant="text"
                      color="error"
                      onClick={() => handleDelete(cache._id, cache.key)}
                    >
                      Delete
                    </Button>
                  </BlockComponent>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </TableLoadingWrapper>
      </Table>
    </TableContainer>
  );
}

